import { getApps, initializeApp, type FirebaseApp } from 'firebase/app'
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics'
import {
  getMessaging,
  getToken,
  isSupported as isMessagingSupported,
} from 'firebase/messaging'

import { env } from './env.config'

function buildFirebaseOptions() {
  const c = env.FIREBASE
  const base = {
    apiKey: c.apiKey,
    authDomain: c.authDomain,
    projectId: c.projectId,
    storageBucket: c.storageBucket,
    messagingSenderId: c.messagingSenderId,
    appId: c.appId,
  }
  if (c.measurementId) {
    return { ...base, measurementId: c.measurementId }
  }
  return base
}

/**
 * App Firebase Web (singleton). Nécessite les variables VITE_FIREBASE_* dans .env.
 */
export function getFirebaseApp(): FirebaseApp {
  if (!getApps().length) {
    return initializeApp(buildFirebaseOptions())
  }
  return getApps()[0] as FirebaseApp
}

/**
 * Google Analytics (Firebase). No-op hors navigateur ou si non supporté / config incomplète.
 */
export async function initFirebaseAnalytics(): Promise<Analytics | null> {
  if (typeof window === 'undefined') return null
  if (!env.FIREBASE.apiKey || !env.FIREBASE.projectId) return null
  if (!(await isSupported())) return null
  return getAnalytics(getFirebaseApp())
}

/**
 * Token FCM Web (après permission notifications + service worker).
 * Nécessite `VITE_FIREBASE_VAPID_KEY` (Console Firebase → Cloud Messaging → Web Push certificates).
 */
export async function requestFcmWebToken(
  vapidKey: string,
): Promise<string | null> {
  if (typeof window === 'undefined') return null
  if (!vapidKey?.trim()) return null
  if (!env.FIREBASE.apiKey || !env.FIREBASE.projectId) return null
  if (!('serviceWorker' in navigator)) return null

  if (!(await isMessagingSupported())) {
    console.warn('[FCM] Messaging non supporté dans ce navigateur')
    return null
  }

  let perm = Notification.permission
  console.log('perm', perm)
  if (perm === 'default') {
    perm = await Notification.requestPermission()
    console.log('perm after request', perm)
  }
  if (perm !== 'granted') {
    return null
  }

  const registration = await navigator.serviceWorker.register(
    '/firebase-messaging-sw.js',
    { scope: '/' },
  )
  await navigator.serviceWorker.ready

  const messaging = getMessaging(getFirebaseApp())
  console.log('getting token')
  console.log('vapidKey', vapidKey.trim())
  console.log('serviceWorkerRegistration', registration)
  const token = await getToken(messaging, {
    vapidKey: vapidKey.trim(),
    serviceWorkerRegistration: registration,
  })

  console.log('token', token)
  return token || null
}
